export default "__VITE_ASSET__DbE7Kxe8__"